// Mapping tables & thresholds used across components (minimal, safe addition)
export const PRODUCT_NAMES = {
    3746: 'Ori v1',
    21593: 'Ori v2',
};

export const SYSTEM_TYPES = {
    4: 'Pocket Studio',    //Studio Suite, Gen 1
    5: 'Pocket Studio',    //Studio Suite, Gen 1
    6: 'Pocket Studio',    //Studio Suite, Gen 1
    7: 'Pocket Studio',    //Studio Suite, Gen 1
    12: 'Pocket Closet',   //Closet, Gen 1
    13: 'Pocket Closet',   //Closet, Gen 2
    14: 'Pocket Closet',   //Closet, Gen 2
    15: 'Cloud Bed',       // Cloud Bed
    16: 'Pocket Studio',   //Studio Suite (Slims and Originals), Gen 2
    17: 'Pocket Studio',   //Studio Suite (Slims and Originals), Gen 2
    18: 'Pocket Studio',   //Studio Suite (Slims and Originals), Gen 2
    19: 'Pocket Studio',   //Studio Suite (Slims and Originals), Gen 2
    20: 'Pocket Closet',   //Pocket Closet, Gen 2
    21: 'Pocket Closet',   //Pocket Closet, Gen 2
    22: 'Cloud Bed Table', // Cloud Bed Table
    23: 'Pocket Office',   // Pocket Office, Gen 2
    24: 'Pocket Office',   // Pocket Office, Gen 2
    25: 'Pocket Wall',     // Pocket Wall
};

export const STALE_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes for last-heard stale indicator
